<template>
    <v-dialog v-model="openMode" max-width="860px" content-class="us-dialog" overlay-color="#0d2c6d"
        overlay-opacity="0.55" transition="dialog-bottom-transition" :persistent="progressShow">
        <v-card class="us-dlg-card">

            <!-- ───────── HEADER (purple-flourished navy, matching the page theme) ───────── -->
            <div class="us-dlg-head">
                <div class="us-dlg-head__main">
                    <div class="us-dlg-head__icon" aria-hidden="true">
                        <v-icon color="#fff" size="22">
                            {{ formTitle === 'ערוך משתמש' ? 'mdi-account-edit-outline' : 'mdi-account-plus-outline' }}
                        </v-icon>
                    </div>
                    <div>
                        <span class="us-dlg-eyebrow">משתמשים</span>
                        <h2 class="us-dlg-title">{{ formTitle }}</h2>
                    </div>
                </div>
                <button type="button" class="us-dlg-close" @click="openMode = false" :disabled="progressShow"
                    aria-label="סגור">
                    <v-icon color="#fff" size="18">mdi-close</v-icon>
                </button>
            </div>

            <!-- ───────── BODY ───────── -->
            <v-card-text class="us-dlg-body">
                <v-form @submit.prevent="submitHandler" ref="form">

                    <!-- Section: Personal -->
                    <div class="us-dlg-section">
                        <h3 class="us-dlg-section__title">
                            <span class="us-dlg-section__bar"></span>
                            פרטים אישיים
                        </h3>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field outlined dense v-model="itemEdited.name" label="שם"
                                    prepend-inner-icon="mdi-account" :rules="[requiredRule]" required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field outlined dense v-model="itemEdited.card_id" type="number"
                                    hide-spin-buttons label="ת.ז / ח.פ"
                                    prepend-inner-icon="mdi-card-account-details-outline"
                                    :rules="[requiredRule, cardIdRule]" required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field outlined dense v-model="itemEdited.phone" type="number" hide-spin-buttons
                                    label="טלפון" prepend-inner-icon="mdi-phone" :rules="[requiredRule, phoneRule]"
                                    required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field outlined dense v-model="itemEdited.email" label="אימייל"
                                    prepend-inner-icon="mdi-email-outline" :rules="[requiredRule, emailRule]"
                                    required></v-text-field>
                            </v-col>
                        </v-row>
                    </div>

                    <!-- Section: Credentials (CREATE ONLY) -->
                    <div v-if="formTitle !== 'ערוך משתמש'" class="us-dlg-section">
                        <h3 class="us-dlg-section__title">
                            <span class="us-dlg-section__bar"></span>
                            פרטי כניסה
                        </h3>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field outlined dense v-model="passObj.password" label="סיסמה"
                                    prepend-inner-icon="mdi-lock-outline" type="password"
                                    :rules="[requiredRule, passwordRule]" required></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field outlined dense v-model="passObj.repeat_password" label="אימות סיסמה"
                                    prepend-inner-icon="mdi-lock-check-outline" type="password" :rules="[requiredRule]"
                                    required></v-text-field>
                            </v-col>
                        </v-row>
                    </div>

                    <!-- Section: Shop -->
                    <div class="us-dlg-section">
                        <h3 class="us-dlg-section__title">
                            <span class="us-dlg-section__bar"></span>
                            פרטי חנות
                        </h3>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field outlined dense v-model="itemEdited.shop_name" label="שם החנות"
                                    prepend-inner-icon="mdi-storefront-outline"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field outlined dense v-model="itemEdited.shop_address" label="מיקום החנות"
                                    prepend-inner-icon="mdi-map-marker-outline"></v-text-field>
                            </v-col>
                        </v-row>
                    </div>

                    <!-- Section: Permissions & Status -->
                    <div class="us-dlg-section">
                        <h3 class="us-dlg-section__title">
                            <span class="us-dlg-section__bar"></span>
                            הרשאות וסטטוס
                        </h3>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-select outlined dense :items="rolesOptions" :item-text="'hebrewName'"
                                    :item-value="'name'" v-model="itemEdited.role" label="הרשאות"
                                    prepend-inner-icon="mdi-shield-account-outline" hide-details="auto"
                                    :rules="[requiredRule]" required></v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-select outlined dense :items="status" :item-text="'hebrewName'" :item-value="'name'"
                                    v-model="itemEdited.status" label="סטטוס" prepend-inner-icon="mdi-power-standby"
                                    hide-details></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" v-if="itemEdited.role === 'seller'">
                                <v-text-field outlined dense v-model="itemEdited.setup_fee" type="number"
                                    hide-spin-buttons label="דמי הקמה" prepend-inner-icon="mdi-currency-ils"
                                    :rules="[nonNegativeNumberRule]"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" v-if="itemEdited.role === 'agent'">
                                <v-file-input outlined dense v-model="logoAttached" accept="image/*" prepend-icon=""
                                    prepend-inner-icon="mdi-image-outline" label="לוגו סוכן"
                                    placeholder="לא נבחרו קבצים" show-size
                                    :rules="[logoTypeRule, logoSizeRule]"></v-file-input>
                            </v-col>
                        </v-row>
                    </div>

                    <!-- Section: Departments (SELLER ONLY) -->
                    <div v-if="itemEdited.role === 'seller'" class="us-dlg-section">
                        <h3 class="us-dlg-section__title">
                            <span class="us-dlg-section__bar"></span>
                            מספרי מחלקות לפי חברות
                        </h3>

                        <v-expansion-panels accordion flat class="us-departments">
                            <!-- HOT MOBILE -->
                            <v-expansion-panel class="us-dept">
                                <v-expansion-panel-header class="us-dept__header">
                                    <template v-slot:default="{ open }">
                                        <div class="us-dept__head-row">
                                            <div class="us-dept__brand us-dept__brand--hot">
                                                <v-icon size="18">mdi-cellphone-wireless</v-icon>
                                            </div>
                                            <div class="us-dept__title-wrap">
                                                <div class="us-dept__name">הוט מובייל</div>
                                                <div class="us-dept__summary" v-if="!open">
                                                    הו"ק: {{ itemEdited.department_numbers?.hotMobile?.bankHok || '—' }}
                                                    <span class="us-dept__sep">·</span>
                                                    אשראי: {{ itemEdited.department_numbers?.hotMobile?.creditCard ||
                                                        '—' }}
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row dense class="px-2 py-1">
                                        <v-col cols="12" sm="6">
                                            <v-text-field outlined dense type="number" hide-spin-buttons
                                                v-model.number="itemEdited.department_numbers.hotMobile.bankHok"
                                                label="מספר מחלקה - הוראת קבע" prepend-inner-icon="mdi-bank-outline"
                                                hide-details="auto" :rules="[nonNegativeIntegerRule]"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field outlined dense type="number" hide-spin-buttons
                                                v-model.number="itemEdited.department_numbers.hotMobile.creditCard"
                                                label="מספר מחלקה - אשראי" prepend-inner-icon="mdi-credit-card-outline"
                                                hide-details="auto" :rules="[nonNegativeIntegerRule]"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <!-- PARTNER -->
                            <v-expansion-panel class="us-dept">
                                <v-expansion-panel-header class="us-dept__header">
                                    <template v-slot:default="{ open }">
                                        <div class="us-dept__head-row">
                                            <div class="us-dept__brand us-dept__brand--partner">
                                                <v-icon size="18">mdi-cellphone-wireless</v-icon>
                                            </div>
                                            <div class="us-dept__title-wrap">
                                                <div class="us-dept__name">פרטנר</div>
                                                <div class="us-dept__summary" v-if="!open">
                                                    הו"ק: {{ itemEdited.department_numbers?.partner?.bankHok || '—' }}
                                                    <span class="us-dept__sep">·</span>
                                                    אשראי: {{ itemEdited.department_numbers?.partner?.creditCard || '—'
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row dense class="px-2 py-1">
                                        <v-col cols="12" sm="6">
                                            <v-text-field outlined dense type="number" hide-spin-buttons
                                                v-model.number="itemEdited.department_numbers.partner.bankHok"
                                                label="מספר מחלקה - הוראת קבע" prepend-inner-icon="mdi-bank-outline"
                                                hide-details="auto" :rules="[nonNegativeIntegerRule]"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field outlined dense type="number" hide-spin-buttons
                                                v-model.number="itemEdited.department_numbers.partner.creditCard"
                                                label="מספר מחלקה - אשראי" prepend-inner-icon="mdi-credit-card-outline"
                                                hide-details="auto" :rules="[nonNegativeIntegerRule]"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <!-- CLICK-CALL MOBILE -->
                            <v-expansion-panel class="us-dept">
                                <v-expansion-panel-header class="us-dept__header">
                                    <template v-slot:default="{ open }">
                                        <div class="us-dept__head-row">
                                            <div class="us-dept__brand us-dept__brand--click">
                                                <v-icon size="18">mdi-cellphone-wireless</v-icon>
                                            </div>
                                            <div class="us-dept__title-wrap">
                                                <div class="us-dept__name">קליק-קול מובייל</div>
                                                <div class="us-dept__summary" v-if="!open">
                                                    הו"ק: {{ itemEdited.department_numbers?.clickCallMobile?.bankHok ||
                                                        '—' }}
                                                    <span class="us-dept__sep">·</span>
                                                    אשראי: {{ itemEdited.department_numbers?.clickCallMobile?.creditCard
                                                        || '—' }}
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row dense class="px-2 py-1">
                                        <v-col cols="12" sm="6">
                                            <v-text-field outlined dense type="number" hide-spin-buttons
                                                v-model.number="itemEdited.department_numbers.clickCallMobile.bankHok"
                                                label="מספר מחלקה - הוראת קבע" prepend-inner-icon="mdi-bank-outline"
                                                hide-details="auto" :rules="[nonNegativeIntegerRule]"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field outlined dense type="number" hide-spin-buttons
                                                v-model.number="itemEdited.department_numbers.clickCallMobile.creditCard"
                                                label="מספר מחלקה - אשראי" prepend-inner-icon="mdi-credit-card-outline"
                                                hide-details="auto" :rules="[nonNegativeIntegerRule]"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </div>

                    <!-- Section: Allowed communities (SELLER ONLY, set by ADMIN only) -->
                    <div v-if="itemEdited.role === 'seller' && isAdmin" class="us-dlg-section">
                        <h3 class="us-dlg-section__title">
                            <span class="us-dlg-section__bar"></span>
                            קהילות מאושרות
                            <span class="us-comm-count">{{ itemEdited.allowed_communities.length }} / {{ allCommunities.length }}</span>
                        </h3>
                        <v-autocomplete outlined dense multiple small-chips deletable-chips
                            v-model="itemEdited.allowed_communities" :items="allCommunities" item-text="name"
                            item-value="_id" :loading="communitiesLoading" :search-input.sync="communitySearch"
                            @change="communitySearch = ''" label="קהילות שיוצגו למשווק בהקמת לקוח"
                            prepend-inner-icon="mdi-account-group-outline" no-data-text="לא נמצאו קהילות"
                            hide-details :menu-props="{ maxHeight: 320 }">
                            <template v-slot:prepend-item>
                                <div class="us-comm-actions">
                                    <button type="button" class="us-comm-action" @click="selectAllCommunities">בחר הכל</button>
                                    <button type="button" class="us-comm-action" @click="clearCommunities">נקה</button>
                                </div>
                                <v-divider class="mt-1"></v-divider>
                            </template>
                        </v-autocomplete>
                        <p v-if="!itemEdited.allowed_communities.length" class="us-comm-hint">
                            משווק בלי קהילות מאושרות לא יוכל לשייך לקוח חדש לקהילה
                        </p>
                        <div v-else class="us-comm-spacer"></div>
                    </div>

                </v-form>
            </v-card-text>

            <!-- ───────── FOOTER ───────── -->
            <div class="us-dlg-foot">
                <v-progress-linear v-if="progressShow" indeterminate color="#8066f0" height="2" />
                <div class="us-dlg-foot__actions">
                    <button type="button" class="us-dlg-btn us-dlg-btn--ghost" @click="openMode = false"
                        :disabled="progressShow">ביטול</button>
                    <button type="button" class="us-dlg-btn us-dlg-btn--primary"
                        @click="formTitle === 'ערוך משתמש' ? saveEditedUser() : saveNewUser()" :disabled="progressShow">
                        <v-icon v-if="!progressShow" size="16" color="#fff">
                            {{ formTitle === 'ערוך משתמש' ? 'mdi-check' : 'mdi-account-plus' }}
                        </v-icon>
                        <span>{{ progressShow ? 'שומר...' : (formTitle === 'ערוך משתמש' ? 'שמור שינויים' : 'צור משתמש')
                            }}</span>
                    </button>
                </div>
            </div>

        </v-card>

        <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
    </v-dialog>
</template>

<script>
import SnackBar from '@/components/widgets/snackBar.vue'
import ApiServices from '@/services/api.service'
import Auth from '@/services/auth.service';
import SharedFunctions from '@/shared/SharedFunctions';

export default {
    props: {
        itemToEdit: Object,
        formTitle: String,
        customerZeut: String,
        value: { type: Boolean, default: false },
    },
    components: {
        SnackBar,
    },
    data: () => ({
        progressShow: false,
        snackbar: false,
        snackbarColorBt: "green",
        snacbarText: "",
        itemEdited: {
            _id: "",
            card_id: "",
            status: true,
            name: "",
            phone: "",
            shop_name: "",
            shop_address: "",
            setup_fee: 0,
            logo: "",
            allowed_communities: [],
            department_numbers: {
                hotMobile: {
                    bankHok: 0,
                    creditCard: 0
                },
                partner: {
                    bankHok: 0,
                    creditCard: 0
                },
                clickCallMobile: {
                    bankHok: 0,
                    creditCard: 0
                }
            }
        },
        logoAttached: null,
        allCommunities: [],
        communitiesLoading: false,
        communitySearch: "",
        passObj: {
            password: "",
            repeat_password: "",
        },
        status: [{ hebrewName: "פעיל", name: true }, { hebrewName: "לא פעיל", name: false }],
    }),

    methods: {
        async saveNewUser() {

            if (this.$refs.form.validate()) {

                if (this.passObj.password !== this.passObj.repeat_password) {
                    return this.showSnackBar("נא לאמת את הסיסמה", "red");
                }

                const isValidCardId = this.is_israeli_id_number(this.itemEdited.card_id);
                if (!isValidCardId) {
                    return this.showSnackBar("תעודת הזהות אינה תקינה", "red");
                }

                this.progressShow = true;
                let token = localStorage.getItem("token");
                let formData = new FormData();
                formData.append("logo", this.logoAttached);
                formData.append("user", JSON.stringify(this.itemEdited));
                formData.append("passObj", JSON.stringify(this.passObj));
                let requestOptions = {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                    body: formData,
                };

                try {
                    let api = process.env.VUE_APP_BASE_URL + "/users/create_user";
                    const res = await fetch(api, requestOptions);
                    this.progressShow = false;
                    const jsonObject = await res.json();
                    if (res.status >= 400) {
                        this.showSnackBar("שגיאה בהוספת משתמש" + jsonObject.message, "red");
                    } else if (res.status === 200) {
                        this.itemEdited._id = jsonObject._id
                        this.$emit("userAdded", this.itemEdited, "המשתמש נוצר בהצלחה!", "green");
                        this.openMode = false;
                    }
                } catch (error) {
                    this.progressShow = false;
                    this.showSnackBar("Error saved user: " + error, "red");
                }
            }

        },
        async saveEditedUser() {

            if (this.$refs.form.validate()) {

                const isValidCardId = this.is_israeli_id_number(this.itemEdited.card_id);
                if (!isValidCardId) {
                    return this.showSnackBar("תעודת הזהות אינה תקינה", "red");
                }

                this.progressShow = true;
                let token = localStorage.getItem("token");
                let formData = new FormData();
                formData.append("logo", this.logoAttached);
                formData.append("user", JSON.stringify(this.itemEdited));
                let requestOptions = {
                    method: 'PUT',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                    body: formData,
                };

                try {
                    let api = process.env.VUE_APP_BASE_URL + "/users/edit_user";
                    const res = await fetch(api, requestOptions);
                    this.progressShow = false;
                    const jsonObject = await res.json();
                    if (res.status >= 400) {
                        this.showSnackBar("שגיאה בעריכת משתמש" + jsonObject.message, "red");
                    } else if (res.status === 200) {
                        this.$emit("userEdited", this.itemEdited, "המשתמש עודכן בהצלחה!", "green");
                        this.openMode = false;
                    }
                } catch (error) {
                    this.progressShow = false;
                    this.showSnackBar("Error edit user: " + error, "red");

                }
            }
        },
        requiredRule(value) {
            return (value !== null && value !== undefined && String(value).trim() !== "") || "שדה חובה";
        },
        cardIdRule(value) {
            return (!value || /^\d{1,9}$/.test(String(value))) || "תעודת זהות חייבת להכיל עד 9 ספרות";
        },
        phoneRule(value) {
            return (!value || /^\d{9,10}$/.test(String(value))) || "מספר טלפון חייב להכיל 9 או 10 ספרות";
        },
        emailRule(value) {
            return (!value || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(String(value))) || "כתובת האימייל אינה תקינה";
        },
        passwordRule(value) {
            return (!value || (/^[A-Za-z0-9]{9,}$/.test(String(value)) && /[A-Za-z]/.test(String(value)) && /\d/.test(String(value)))) || "הסיסמה חייבת להכיל לפחות 9 תווים, כולל אותיות באנגלית ומספרים";
        },
        nonNegativeNumberRule(value) {
            return (value === "" || value === null || value === undefined || (Number.isFinite(Number(value)) && Number(value) >= 0)) || "יש להזין מספר שאינו שלילי";
        },
        nonNegativeIntegerRule(value) {
            return (value === "" || value === null || value === undefined || /^\d+$/.test(String(value))) || "יש להזין מספר שלם שאינו שלילי";
        },
        logoTypeRule(value) {
            if (!value) return true;
            const file = Array.isArray(value) ? value[0] : value;
            return (!file?.type || file.type.startsWith("image/")) || "ניתן להעלות קובץ תמונה בלבד";
        },
        logoSizeRule(value) {
            if (!value) return true;
            const file = Array.isArray(value) ? value[0] : value;
            return (!file?.size || file.size <= 5 * 1024 * 1024) || "גודל התמונה המקסימלי הוא 5MB";
        },
        is_israeli_id_number(id) {
            id = String(id).trim();
            if (id.length > 9 || isNaN(id)) return false;
            id = id.length < 9 ? ("00000000" + id).slice(-9) : id;
            return Array.from(id, Number).reduce((counter, digit, i) => {
                const step = digit * ((i % 2) + 1);
                return counter + (step > 9 ? step - 9 : step);
            }) % 10 === 0;
        },
        showSnackBar(message, color) {
            this.snacbarText = message;
            this.snackbarColorBt = color;
            this.snackbar = true
        },
        async loadCommunities() {
            this.communitiesLoading = true;
            try {
                this.allCommunities = await SharedFunctions.getCommunities();
            } finally {
                this.communitiesLoading = false;
            }
        },
        selectAllCommunities() {
            this.itemEdited.allowed_communities = this.allCommunities.map(community => community._id);
        },
        clearCommunities() {
            this.itemEdited.allowed_communities = [];
        },
    },
    computed: {
        openMode: {
            get() {
                return this.value
            },
            set(v) {
                return this.$emit('input', v)
            }
        },
        isAdmin() {
            return Auth.getUserRole() === "admin";
        },
        rolesOptions() {
            return Auth.getUserRole() === "admin" ? [{ hebrewName: "מנהל", name: "admin" }, { hebrewName: "סוכן", name: "agent" }, { hebrewName: "משווק", name: "seller" }]
                : [{ hebrewName: "משווק", name: "seller" }]
        }
    },
    mounted() {
        if (this.formTitle === "ערוך משתמש") {
            this.itemEdited = JSON.parse(JSON.stringify(this.itemToEdit));
            this.itemEdited.status = this.itemEdited.status === "פעיל" ? true : false;
            this.itemEdited.role = this.itemEdited.role === "מנהל" ? "admin" : this.itemEdited.role === "סוכן" ? "agent" : "seller";

            // אתחול מספרי מחלקות אם לא קיימים
            if (!this.itemEdited.department_numbers) {
                this.itemEdited.department_numbers = {
                    hotMobile: { bankHok: 0, creditCard: 0 },
                    partner: { bankHok: 0, creditCard: 0 },
                    clickCallMobile: { bankHok: 0, creditCard: 0 }
                };
            }

            // אתחול קהילות מאושרות אם לא קיימות
            if (!Array.isArray(this.itemEdited.allowed_communities)) {
                this.$set(this.itemEdited, "allowed_communities", []);
            }
        }

        // רשימת כל הקהילות לבחירה - רק לאדמין
        if (this.isAdmin) {
            this.loadCommunities();
        }
    },
}
</script>

<style scoped>
.us-dialog {
    border-radius: 20px !important;
    overflow: hidden;
}

.us-dlg-card {
    --c-navy: #0d2c6d;
    --c-purple: #8066f0;
    --c-purple-deep: #6b54e0;
    --c-border-soft: #eef2f7;
    --c-text: #0f172a;
    --c-text-soft: #475569;
    --c-text-mute: #94a3b8;
    font-family: 'Assistant', 'Heebo', system-ui, sans-serif;
    direction: rtl;
    background: #ffffff !important;
    border-radius: 20px !important;
    overflow: hidden;
}

/* ─── HEADER (purple flourish — Users theme) ─── */
.us-dlg-head {
    background:
        radial-gradient(700px 200px at 90% -40%, rgba(128, 102, 240, 0.30), transparent 60%),
        linear-gradient(135deg, #0d2c6d 0%, #1a2570 55%, #2a2a8a 100%);
    color: #fff;
    padding: 18px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.us-dlg-head__main {
    display: flex;
    align-items: center;
    gap: 14px;
}

.us-dlg-head__icon {
    width: 42px;
    height: 42px;
    border-radius: 11px;
    background: rgba(128, 102, 240, 0.32);
    border: 1px solid rgba(255, 255, 255, 0.22);
    display: grid;
    place-items: center;
}

.us-dlg-eyebrow {
    display: block;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.65);
    margin-bottom: 1px;
}

.us-dlg-title {
    margin: 0;
    font-size: 1.15rem;
    font-weight: 800;
    letter-spacing: -0.01em;
    color: #fff;
}

.us-dlg-close {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.10);
    border: 1px solid rgba(255, 255, 255, 0.18);
    color: #fff;
    cursor: pointer;
    display: grid;
    place-items: center;
    transition: background 0.2s, transform 0.2s;
}

.us-dlg-close:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.18);
    transform: rotate(90deg);
}

.us-dlg-close:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* ─── BODY ─── */
.us-dlg-body {
    padding: 22px 26px 8px !important;
    background: #fbfcfe;
    max-height: 68vh;
    overflow-y: auto;
}

.us-dlg-section {
    margin-bottom: 16px;
    padding: 16px 18px 6px;
    background: #ffffff;
    border: 1px solid var(--c-border-soft);
    border-radius: 14px;
}

.us-dlg-section__title {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 0.92rem;
    font-weight: 700;
    color: var(--c-navy);
    margin: 0 0 14px;
}

.us-dlg-section__bar {
    width: 3px;
    height: 16px;
    /* Navy → purple — Users page accent */
    background: linear-gradient(180deg, var(--c-navy), var(--c-purple));
    border-radius: 2px;
}

/* ─── Allowed communities ─── */
.us-comm-count {
    margin-inline-start: auto;
    font-size: 0.78rem;
    font-weight: 700;
    color: var(--c-text-soft);
    background: #f2f0fe;
    border-radius: 999px;
    padding: 2px 10px;
    font-feature-settings: "tnum" 1;
}

.us-comm-actions {
    display: flex;
    gap: 8px;
    padding: 6px 12px 2px;
}

.us-comm-action {
    font: inherit;
    font-size: 0.82rem;
    font-weight: 700;
    color: var(--c-purple-deep);
    background: transparent;
    border: 1px solid #ddd6fe;
    border-radius: 8px;
    padding: 3px 12px;
    cursor: pointer;
}

.us-comm-action:hover {
    background: #f5f3ff;
}

.us-comm-hint {
    margin: 8px 2px 10px;
    font-size: 0.82rem;
    font-weight: 600;
    color: #b45309;
}

.us-comm-spacer {
    height: 10px;
}

::v-deep .v-text-field--outlined fieldset,
::v-deep .v-select--outlined fieldset,
::v-deep .v-file-input fieldset {
    border-color: #e3e8ef !important;
    transition: border-color 0.2s, box-shadow 0.2s;
}

::v-deep .v-text-field--outlined:hover fieldset,
::v-deep .v-select--outlined:hover fieldset {
    border-color: #c7d2e0 !important;
}

::v-deep .v-input--is-focused fieldset {
    border-color: var(--c-purple) !important;
    border-width: 2px !important;
    box-shadow: 0 0 0 4px rgba(128, 102, 240, 0.08);
}

::v-deep .v-input__prepend-inner {
    margin-top: 9px !important;
}

::v-deep .v-input__prepend-inner .v-icon {
    color: var(--c-text-mute) !important;
}

::v-deep .v-input--is-focused .v-input__prepend-inner .v-icon {
    color: var(--c-purple) !important;
}

/* ─── DEPARTMENTS (expansion panels) ─── */
.us-departments {
    background: transparent !important;
    border-radius: 12px;
}

::v-deep .us-dept {
    background: #fbfcfe !important;
    border: 1px solid var(--c-border-soft) !important;
    border-radius: 12px !important;
    margin-bottom: 8px;
}

::v-deep .us-dept::before {
    display: none !important;
}

::v-deep .us-dept .v-expansion-panel-header {
    padding: 12px 14px !important;
    min-height: 56px !important;
}

::v-deep .us-dept .v-expansion-panel-content__wrap {
    padding: 8px 14px 14px !important;
}

.us-dept__head-row {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
}

.us-dept__brand {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: grid;
    place-items: center;
    color: #fff;
}

/* Carrier brand colors — instantly recognizable */
.us-dept__brand--hot {
    background: linear-gradient(135deg, #e30613 0%, #c10510 100%);
}

.us-dept__brand--partner {
    background: linear-gradient(135deg, #16a34a 0%, #128a3d 100%);
}

.us-dept__brand--click {
    background: linear-gradient(135deg, #fdb721 0%, #fdb721 100%);

}

.us-dept__title-wrap {
    display: flex;
    flex-direction: column;
    gap: 1px;
    min-width: 0;
    flex: 1;
}

.us-dept__name {
    font-size: 0.95rem;
    font-weight: 700;
    color: var(--c-text);
}

.us-dept__summary {
    font-size: 0.78rem;
    color: var(--c-text-mute);
    font-weight: 600;
}

.us-dept__sep {
    margin: 0 5px;
    opacity: 0.5;
}

/* ─── FOOTER ─── */
.us-dlg-foot {
    background: #ffffff;
    border-top: 1px solid var(--c-border-soft);
}

.us-dlg-foot__actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 14px 22px;
}

.us-dlg-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 9px 22px;
    border-radius: 10px;
    border: none;
    font-family: inherit;
    font-weight: 700;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.22, 1, 0.36, 1);
}

.us-dlg-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.us-dlg-btn--ghost {
    background: transparent;
    color: var(--c-text-soft);
    border: 1px solid #e3e8ef;
}

.us-dlg-btn--ghost:hover:not(:disabled) {
    background: #f8fafc;
    color: var(--c-text);
}

/* Purple primary — Users theme */
.us-dlg-btn--primary {
    background: linear-gradient(135deg, var(--c-purple) 0%, var(--c-purple-deep) 100%);
    color: #fff;
    box-shadow: 0 6px 14px -4px rgba(128, 102, 240, 0.50);
}

.us-dlg-btn--primary:hover:not(:disabled) {
    transform: translateY(-1px);
    filter: brightness(1.08);
}

@media (max-width: 600px) {
    .us-dlg-head {
        padding: 14px 18px;
    }

    .us-dlg-title {
        font-size: 1rem;
    }

    .us-dlg-body {
        padding: 18px 18px 4px !important;
    }

    .us-dlg-section {
        padding: 14px 14px 4px;
    }

    .us-dlg-foot__actions {
        padding: 12px 16px;
    }

    .us-dlg-btn {
        padding: 9px 16px;
        font-size: 0.85rem;
    }
}
</style>